/* sticky add-to-cart bar — PDP */

(function () {
  'use strict';

  var bar = document.getElementById('yg-sticky-atc');
  if (!bar) return;

  var NATIVE_ATC = '.buy-buttons-block button[name="add"], .buy-buttons-block [ref="addToCartButton"]';
  var WIDGET_ATC = '[class*="gfbFooterAddToCartBtn"], .gfbFrequentBoughtWidgetAddToCartButtonEle, .gfbFrequentBoughtAddToCartButton';
  var MAIN_PICKER = 'variant-picker[data-template-product-match="true"]';

  var scrim = document.getElementById('yg-sticky-atc-scrim');
  var trigger = document.getElementById('yg-sticky-atc-size');
  var triggerLabel = document.getElementById('yg-sticky-atc-size-label');
  var pop = document.getElementById('yg-sticky-atc-sizes');
  var grid = document.getElementById('yg-sticky-atc-grid');
  var stickyBtn = document.getElementById('yg-sticky-atc-btn');
  var ctaWords = stickyBtn.querySelectorAll('.yg-sticky-atc__btn-word');

  // both layers of the hover swap carry the label, so the success state can't strand one
  function setCtaLabel(text) {
    for (var i = 0; i < ctaWords.length; i++) ctaWords[i].textContent = text;
  }

  function isRendered(el) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }

  function pickRendered(selector) {
    var nodes = document.querySelectorAll(selector);
    for (var i = 0; i < nodes.length; i++) {
      if (isRendered(nodes[i])) return nodes[i];
    }
    return null;
  }

  function resolveAtc() {
    return pickRendered(NATIVE_ATC) || pickRendered(WIDGET_ATC);
  }

  function resolveAnchor() {
    var native = document.querySelector('.product-form-buttons');
    if (isRendered(native)) return native;
    var block = document.querySelector('.gfbFrequentBoughtWrapper');
    return isRendered(block) ? block : null;
  }

  function resolveFooter() {
    // the fixed footer never leaves the viewport; its reveal spacer is the in-flow stand-in
    var spacer = document.querySelector('.yg-footer-reveal');
    if (isRendered(spacer)) return spacer;

    var section = document.querySelector('[id^="shopify-section-"][id$="__footer"]');
    if (isRendered(section)) return section;
    var footers = document.querySelectorAll('body > footer, #MainContent ~ footer');
    var last = footers[footers.length - 1];
    return isRendered(last) ? last : null;
  }

  var beforeAnchor = true;
  var anchorReported = false;
  var footerInView = false;
  var menuOpen = false;

  function applyVisibility() {
    // the footer observer can report first; nothing shows until the buy block's state is known
    if (!anchorReported) return;
    if (beforeAnchor || footerInView || menuOpen) {
      bar.classList.add('yg-hidden');
      bar.setAttribute('aria-hidden', 'true');
      closePopover();
    } else {
      bar.style.display = 'flex';
      bar.classList.remove('yg-hidden');
      bar.setAttribute('aria-hidden', 'false');
    }
  }

  /* Measured off the rect, not an IntersectionObserver: below the fold and
     above the viewport are the same non-intersecting bucket, so a jump that
     clears the buy block in one frame - a restored scroll position, an in-page
     anchor - crosses no threshold, fires no callback, and would strand the bar
     hidden for the rest of the page. */
  function measureAnchor() {
    if (!watched) return;
    var next = watched.getBoundingClientRect().bottom > 0;
    if (anchorReported && next === beforeAnchor) return;
    beforeAnchor = next;
    anchorReported = true;
    applyVisibility();
  }

  var measureQueued = false;
  function queueMeasure() {
    if (measureQueued) return;
    measureQueued = true;
    requestAnimationFrame(function () { measureQueued = false; measureAnchor(); });
  }

  window.addEventListener('scroll', queueMeasure, { passive: true });
  window.addEventListener('resize', queueMeasure);

  // the lead clears the bar's own height so it is gone before the footer reaches it
  var footerObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { footerInView = e.isIntersecting; });
    applyVisibility();
  }, { rootMargin: '0px 0px 100px 0px' });

  /* mobile nav drawer — keyed on the open attribute, not .menu-open:
     header-drawer.js drops the class first and only resets open once the close
     animation ends, so the attribute is the one that spans the whole time the
     panel is on screen. Capture phase, since toggle does not bubble. */
  var MENU_DRAWER = 'details.menu-drawer-container';

  function syncMenu() {
    menuOpen = !!document.querySelector(MENU_DRAWER + '[open]');
  }

  document.addEventListener('toggle', function (e) {
    var el = e.target;
    if (!el || !el.matches || !el.matches(MENU_DRAWER)) return;
    syncMenu();
    applyVisibility();
  }, true);

  function syncPrepaid() {
    var prepaid = bar.querySelector('.yg-sticky-atc__prepaid');
    if (prepaid) prepaid.style.display = isRendered(document.getElementById('gokwik-buy-now')) ? '' : 'none';
  }

  /* size options — read straight off the real variant picker */

  function sizeInputs() {
    var picker = pickRendered(MAIN_PICKER);
    if (!picker) return null;
    var sets = picker.querySelectorAll('fieldset.variant-option--buttons');
    var chosen = null;
    for (var i = 0; i < sets.length; i++) {
      var legend = sets[i].querySelector('legend');
      if (legend && /size/i.test(legend.textContent)) { chosen = sets[i]; break; }
    }
    if (!chosen && sets.length === 1) chosen = sets[0];
    if (!chosen) return null;
    var inputs = chosen.querySelectorAll('input[type="radio"]');
    return inputs.length ? [].slice.call(inputs) : null;
  }

  function signature(inputs) {
    return inputs.map(function (i) {
      return i.value + '/' + i.dataset.optionAvailable + '/' + (i.checked ? 1 : 0);
    }).join('|');
  }

  var lastSignature = null;

  function renderSizes() {
    var inputs = sizeInputs();
    if (!inputs) {
      trigger.hidden = true;
      lastSignature = null;
      grid.textContent = '';
      closePopover();
      return;
    }
    var sig = signature(inputs);
    if (sig === lastSignature) return;
    lastSignature = sig;

    trigger.hidden = false;
    var cols = inputs.length > 5 ? Math.ceil(inputs.length / 2) : inputs.length;
    grid.style.setProperty('--yg-sa-cols', cols);
    grid.textContent = '';

    var selected = null;
    inputs.forEach(function (input) {
      var opt = document.createElement('button');
      opt.type = 'button';
      opt.className = 'yg-sticky-atc__size-opt';
      opt.setAttribute('role', 'option');
      opt.textContent = input.value;
      if (input.dataset.optionAvailable === 'false') {
        opt.disabled = true;
        opt.setAttribute('aria-disabled', 'true');
      }
      if (input.checked) {
        selected = input.value;
        opt.classList.add('is-selected');
      }
      opt.setAttribute('aria-selected', input.checked ? 'true' : 'false');
      opt.addEventListener('click', function () { chooseSize(input); });
      grid.appendChild(opt);
    });

    triggerLabel.textContent = selected || 'Size';
    if (selected) trigger.classList.remove('is-error');
  }

  var pendingVariantId = null;

  function chooseSize(input) {
    if (!input.checked) input.click();
    pendingVariantId = input.dataset.variantId || null;
    triggerLabel.textContent = input.value;
    trigger.classList.remove('is-error');
    [].forEach.call(grid.children, function (opt) {
      var on = opt.textContent === input.value;
      opt.classList.toggle('is-selected', on);
      opt.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    closePopover();
    trigger.focus();
  }

  function armedVariantId() {
    var anchor = resolveAnchor();
    var form = anchor && anchor.closest ? anchor.closest('form') : null;
    var input = form ? form.querySelector('input[name="id"]') : null;
    return input ? input.value : null;
  }

  function variantReady() {
    if (!pendingVariantId) return true;
    var armed = armedVariantId();
    if (armed === null || armed === pendingVariantId) { pendingVariantId = null; return true; }
    return false;
  }

  /* popover */

  function openPopover() {
    if (trigger.hidden) return;
    pop.classList.add('is-open');
    trigger.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');
    scrim.classList.add('is-open');
    // the click that opened this is still propagating towards document
    setTimeout(function () {
      if (pop.classList.contains('is-open')) document.addEventListener('click', outsideClick);
    }, 0);
    document.addEventListener('keydown', escKey);
  }

  function closePopover() {
    pop.classList.remove('is-open');
    trigger.classList.remove('is-open');
    trigger.setAttribute('aria-expanded', 'false');
    scrim.classList.remove('is-open');
    document.removeEventListener('click', outsideClick);
    document.removeEventListener('keydown', escKey);
  }

  function outsideClick(e) {
    if (!pop.contains(e.target) && !trigger.contains(e.target)) closePopover();
  }

  function escKey(e) {
    if (e.key === 'Escape') { closePopover(); trigger.focus(); }
  }

  trigger.addEventListener('click', function (e) {
    e.stopPropagation();
    pop.classList.contains('is-open') ? closePopover() : openPopover();
  });

  scrim.addEventListener('click', closePopover);

  /* proxy click — the real button[name="add"] does the adding, never this one */

  function flagSizeError() {
    if (trigger.hidden) return;
    trigger.classList.add('is-error');
    trigger.addEventListener('animationend', function () {
      trigger.classList.remove('is-error');
    }, { once: true });
    openPopover();
  }

  function fireAtc() {
    var btn = resolveAtc();
    if (!btn || btn.disabled || btn.classList.contains('gfbDisableAddToCart')) {
      flagSizeError();
      return;
    }
    btn.click();
    setCtaLabel('Added ✓');
    stickyBtn.classList.add('is-added');
    setTimeout(function () {
      setCtaLabel('Add to cart');
      stickyBtn.classList.remove('is-added');
    }, 1200);
  }

  stickyBtn.addEventListener('click', function () {
    if (stickyBtn.classList.contains('is-busy')) return;
    if (variantReady()) { fireAtc(); return; }
    stickyBtn.classList.add('is-busy');
    var start = Date.now();
    (function poll() {
      if (variantReady() || Date.now() - start > 2000) {
        pendingVariantId = null;
        stickyBtn.classList.remove('is-busy');
        fireAtc();
        return;
      }
      setTimeout(poll, 60);
    })();
  });

  /* show / hide */

  var watched = null;
  var watchedFooter = null;

  function syncFooter() {
    var footer = resolveFooter();
    if (!footer) {
      if (watchedFooter) { footerObserver.unobserve(watchedFooter); watchedFooter = null; }
      footerInView = false;
      return;
    }
    if (footer === watchedFooter) return;
    if (watchedFooter) footerObserver.unobserve(watchedFooter);
    watchedFooter = footer;
    footerObserver.observe(footer);
  }

  function sync() {
    syncPrepaid();
    renderSizes();
    syncFooter();
    syncMenu();
    var anchor = resolveAnchor();
    if (!anchor) {
      watched = null;
      beforeAnchor = true;
      anchorReported = false;
      bar.style.display = 'none';
      bar.setAttribute('aria-hidden', 'true');
      return;
    }
    watched = anchor;
    measureAnchor();
  }

  var queued = false;
  function queueSync() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; sync(); });
  }

  document.addEventListener('change', function (e) {
    var el = e.target;
    if (!el || !el.closest || !el.closest(MAIN_PICKER)) return;
    renderSizes();
    queueSync();
  });

  function init() {
    sync();
    var scope = document.querySelector('.product-information');
    if (scope && window.MutationObserver) {
      new MutationObserver(queueSync).observe(scope, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class']
      });
    }
  }

  document.addEventListener('shopify:section:load', queueSync);
  window.addEventListener('resize', queueSync);
  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();
